import newColors from "@/styles/newColors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	titleText: {
		maxWidth: "950px",
		fontSize: "32px",
		lineHeight: "38px",
		color: newColors.grey[800]
	},
	copyButton: {
		width: "fit-content",
		fontWeight: 500,
		color: newColors.grey[500],
		"&:hover": {
			textDecoration: "underline",
			background: "transparent",
			color: newColors.blue[700]
		}
	}
}))

export default useStyles
